import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaTimesCircle } from 'react-icons/fa';
import './PaymentCancel.css';

const PaymentCancel = () => {
  const navigate = useNavigate();

  return (
    <div className="payment-cancel">
      <div className="payment-cancel-content">
        <FaTimesCircle className="cancel-icon" />
        <h1>Payment Cancelled</h1>
        <p>Your payment was cancelled. No charges were made.</p>
        <button 
          onClick={() => navigate('/dashboard')}
          className="btn btn-primary"
        >
          Return to Dashboard
        </button>
      </div>
    </div>
  );
};

export default PaymentCancel;
